module.exports = __webpack_public_path__ + "static/media/picto-candle-black.3be865f4.svg";